import React from 'react';
import { Helmet } from 'react-helmet-async';
import DailyQuote from '../components/DailyQuote';
import QuoteGenerator from '../components/QuoteGenerator';

const HomePage = () => {
    const siteUrl = window.location.origin;
    return (
        <div className="page-container">
            <Helmet>
                <title>Captions — Daily Quote Generator | Free Inspirational Quotes</title>
                <meta name="description" content="Get a fresh inspirational quote every day. Download it as a beautiful image card to share on Instagram, WhatsApp, and more. Free, no sign-up needed." />
                <link rel="canonical" href={siteUrl + '/'} />
                <meta property="og:url" content={siteUrl + '/'} />
                <meta property="og:title" content="Captions — Daily Quote Generator | Free Inspirational Quotes" />
                <meta property="og:description" content="Get a fresh inspirational quote every day. Download it as a beautiful image card to share on Instagram, WhatsApp, and more. Free, no sign-up needed." />
            </Helmet>
            <h1>Daily Inspiration</h1>
            <p className="page-subtitle">A new quote every time you need one.</p>
            <DailyQuote />
            <div className="section-divider"><span>discover more</span></div>
            <QuoteGenerator />
        </div>
    );
};

export default HomePage;
